// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type CreateOwnerCorporateDataMutationVariables = Types.Exact<{
  upsertOwnerCorporateDataDTO: Types.UpsertOwnerCorporateDataDtoInput;
}>;


export type CreateOwnerCorporateDataMutationResult = { __typename?: 'Mutation', createOwnerCorporateData: number | null };

export const CreateOwnerCorporateDataGql = gql`
    mutation CreateOwnerCorporateData($upsertOwnerCorporateDataDTO: UpsertOwnerCorporateDataDTOInput!) {
  createOwnerCorporateData(
    upsertOwnerCorporateDataDTO: $upsertOwnerCorporateDataDTO
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateOwnerCorporateDataInjectable extends Apollo.Mutation<CreateOwnerCorporateDataMutationResult, CreateOwnerCorporateDataMutationVariables> {
    override document = CreateOwnerCorporateDataGql;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
/* eslint-enable */